import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Button } from 'react-bootstrap';
import AnimateHeight from 'react-animate-height';

import { formStatusDispatchHelper } from 'actions/FormStatusActions';
import { deleterDispatchHelper } from 'actions/DeleterActions';

import SimplePrompt from 'components/layout/SimplePrompt';
import TableResponsive from 'components/layout/TableResponsive';

import FormAutocomplete from 'components/forms/FormAutocomplete';
import _, {cloneDeep as _cloneDeep, forEach as _forEach} from 'lodash';

import {addSharedEditionUser, deleteSharedEditionUser} from "actions/DataActions";

class ShareableResourceUsers extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      show: false,
      modalList: [],
    };
  }

  componentDidMount = () => {
    const { list } = this.props;
    if(typeof list !== "undefined"){
      this.setState({modalList: list})
    }else{
      if(this.props.type === "edition"){
        const index = _.findIndex(this.props.editions, list => list.id === this.props.id);
        if(index !== -1){
          this.setState({ modalList: this.props.editions[index]?.shared_with_users })
        }
      }
    }
  }

  componentDidUpdate = (prevProps, prevState) => {
    const { modalList } = this.state;
    if(this.props.type === "edition") {
      if(prevProps.shareA.pending !== this.props.shareA.pending && this.props.shareA.pending === false){
        if(this.props.shareA?.response?.shareWithType === "user"){
            this.props.addSharedEditionUser(this.props.id, this.props.shareA?.response?.data);
          let newUserData = {
            username: this.props.shareA?.response?.data?.id,
            profile:{
              company: this.props.shareA?.response?.data?.company,
              first_name: this.props.shareA?.response?.data?.firstName,
              last_name: this.props.shareA?.response?.data?.lastName,
            }
          }
          let _modalList = _cloneDeep(this.state.modalList);
          _modalList.push(newUserData);
            this.setState({ modalList: _modalList });
          }
        }
    }
}

  show = () => {
    this.setState({ show: true });
  };

  addShare = (formPropertyName, shareWithId) => {
    if (shareWithId) {
      const { type, id, doShare } = this.props;
      doShare(type, id, shareWithId);
    }

    this.setState({ show: false });
  };

  removeShare = (e, shareWithId) => {
    e.preventDefault();
    e.stopPropagation();
    const { type, id, doRemoveShare } = this.props;

    if(this.props.type === "edition") {
      this.props.deleteSharedEditionUser(this.props.id, shareWithId)
      let _modalList = _cloneDeep(this.state.modalList)
      let sharedUsers = _.filter(_modalList, x => x.username !== shareWithId);
      this.setState({modalList: sharedUsers});
    }

    doRemoveShare(type, id, shareWithId);
  };

  render() {
    const {
      intl: { messages },
      list,
      mayShare,
      mayRemove,
    } = this.props;
    const { show, modalList } = this.state;

    const headers = {
      user: messages.user,
      actions: messages.actions,
    };
    const rows = [];

    if(modalList !== undefined) {
      _forEach(modalList, (_list, i) => {
        const rowData = {
          user: (
            <React.Fragment key={"sharedUsers" + i}>
              {!!_list?.profile && (
                <>
                  <b>{_list?.profile?.company}</b>
                  <br/>
                </>
              )}
              {_list?.profile?.first_name} {_list?.profile?.last_name}
              </React.Fragment>
          ),
          actions: mayRemove
            ? [
              <SimplePrompt
                key="remove"
                iconClass="fal fa-times"
                buttonLabel={messages.remove_selection}
                onSuccess={e => this.removeShare(e, _list?.username)}
              />,
            ]
            : [],
        };
        rows.push(rowData);
      });
    }

    return (
      <div className="clearfix m-t-20">
        {mayShare && (
          <>
            <AnimateHeight duration={500} height={show ? 'auto' : 0}>
              <div className="form-group-attached">
                <FormAutocomplete
                  label={messages.share_with}
                  onChange={this.addShare}
                  urlFilters={this.props.user?.parent?.username !== null && { filters: { ancestors: this.props.user?.parent?.username }}}
                  autocompleteType="sharing" />
              </div>
            </AnimateHeight>
            <AnimateHeight duration={500} height={!show ? 'auto' : 0}>
              <div className="text-center">
                <Button className="btn-rounded" onClick={this.show}>
                  <i className="fa fa-plus" />{messages.add_user}
                </Button>
              </div>
            </AnimateHeight>
          </>
        )}

        <div className="m-t-15">
          <TableResponsive headers={headers} rows={rows} hover />
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    doShare: (type, id, shareWithId) => {
      const args = {
        shareWithType: 'user',
        shareWithId,
      };
      formStatusDispatchHelper('share', `/api/sharedresources/${type}/${id}.json`, args, 'post', dispatch);
    },
    doRemoveShare: (type, id, shareWithId) => {
      deleterDispatchHelper('share', `/api/sharedresources/${type}/${id}/user/${shareWithId}.json`, dispatch);
    },
    addSharedEditionUser: (editionId, data) => {
      dispatch(addSharedEditionUser(editionId, data));
    },
    deleteSharedEditionUser: (editionId, data) => {
      dispatch(deleteSharedEditionUser(editionId, data));
    },
  };
};

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    shareA: state.formStatus.share,
    shareD: state.deleter.share,
    editions: state.data.campaign.data.editions,
    user: state.login.user,
  };
};

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ShareableResourceUsers)
);
